import api from 'util/api';
import { Trans } from '@lingui/react/macro';


function ServiceRow({row}) {
  function action(which) {
    api(`/diagnostic/${row.serviceName}/${which}`, {method: 'POST'});
  }

  return(
    <tr>
      <td>
        <span className={`status-icon ${(row.serviceStatus || '').toLowerCase()}`}></span>&nbsp;
        {row.displayName}
      </td>
      <td>
        {row.serviceState}
      </td>
      <td>
        {row.physicalMemoryUsage} ({row.peakPhysicalMemoryUsage})
      </td>
      <td>
        {row.pagedMemorySize} ({row.peakPagedMemorySize})
      </td>
      <td>
        {row.pagedSystemMemorySize} ({row.peakPagedSystemMemorySize})
      </td>
      {/* <td>
        <button
          className="start"
          disabled={row.serviceState == 'Running'}
          onClick={() => action('start')}
        >
          <Trans>Start</Trans>
        </button>
        <button
          className="stop"
          disabled={row.serviceState != 'Running'}
          onClick={() => action('stop')}
        >
          <Trans>Stop</Trans>
        </button>
        <button
          className="restart"
          onClick={() => action('restart')}
        >
          <Trans>Restart</Trans>
        </button>
      </td> */}
    </tr>
  );
}

export default ServiceRow;
